<template>
    <div id="app" class="app" :class="appClass">
        <transition name="slide-down">
            <div v-if="offline && $route.name === 'MainView'" class="app-offline">
                <i class="icon-offline"></i>
            </div>
        </transition>

        <transition :name="mainTransition"
                    v-on:before-leave="beforeLeave"
                    v-on:after-leave="afterLeave">
            <router-view v-title="windowTitle"></router-view>
        </transition>

<!--        <transition name="footer">-->
<!--            <v-footer v-show="showFooter" key="mainFooter" />-->
<!--        </transition>-->

        <transition name="modal">
            <download />
        </transition>
    </div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import { USER_REQUEST } from "@/utils/store/actions/user";
	import Footer from "@/components/layouts/Footer";
	import FileDownload from "@/components/plugins/FileDownload";
	import api, { ApiDefaults } from '@/utils/api_call';
    import { STORE_NAVIGATION } from './utils/store/actions/general';
    // import * as Push from '@/utils/firebase';

	export default {
		name: 'App',
		components: {
			'v-footer': Footer,
			'download': FileDownload
		},
		directives: {
			title: {
				inserted: ( el, binding ) => document.title = binding.value,
				update: ( el, binding ) => document.title = binding.value
			}
		},
		data() {
			return {
				offline: false,
				mainTitle: 'Kassecker',
				transitionEffect: 'slide-up',
				transitionDuration: 500,
				mainTransition: 'none',
				footerTransition: 'slide-left',
				showFooter: ! ([ 'MainView', 'Login', 'Logout' ].indexOf(this.$route.name) == -1),
				showOverlay: false
			};
		},
		computed: {
			appClass() {
                let classes = [];
                if( Object(this.$route).hasOwnProperty('name') ) {
                    classes.push('app--' + this.$route.name.toLowerCase());
                }

                classes.push('app--' + this.$store.getters.getViewMode);
				return classes;
			},
			windowTitle() {
				if ( [ 'Aktuelles', 'Infocenter', 'Kalender', 'Notfall' ].indexOf(this.$route.name) >= 0 ) {

					return this.$route.meta.title + ' - ' + this.mainTitle;
				}
				return this.mainTitle;
			},
			...mapGetters([ 'isAuthenticated', 'authStatus', 'getViewMode' ])
		},
		methods: {
			beforeLeave: function ( el ) {

				if ( this.$route.name === 'Kalender' || (this.$route.name === 'MainView' && el.classList.contains('calendar')) ) {
					let header = document.querySelector('.header'),
						content = document.querySelector('.content-wrap.calendar');

					// this.$nextTick(function () {
					// 	header.style.top = content.scrollTop + 'px';
					// });
				}

			},
			afterLeave: function () {
				if ( this.$route.name === 'Kalender' ) {
					let header = document.querySelector('.header');
					header.style.top = 0;
				}
			},
			updateOnlineStatus: function (evt) {
				this.offline = evt.type === "offline";
            },
			fetchMenu: function () {
				let apiParams = Object.assign({}, ApiDefaults, {method: 'get', params: {id: 1, type: 1}});
				this.isOpen = false;
				api(apiParams).then( ( response ) => {
					if ( response.status === 200  ) {
						let pages = response.data.menu.pages;
						// this.menu = pages;
						this.$store.commit( STORE_NAVIGATION, pages )
						this.isOpen = true;
						// return pages;
					}
				});
			}

		},
		watch: {
			'$route': function ( to, from ) {

				this.showFooter = !([ 'MainView', 'Login', 'Logout' ].indexOf(to.name) == -1);

				if ( to.name == 'MainView' && (from.name !== 'Loading' && from.name !== 'Login') ) {
					this.mainTransition = 'slide-right';
				}
				else if ( [ 'MainView', 'Login' ].indexOf(to.name) > -1 &&
					[ 'Loading', 'Login', 'MainView' ].indexOf(from.name) > -1 ) {
					this.mainTransition = 'none';
				}
				else {
					this.mainTransition = 'slide-left';
				}
			}
		},
		created() {

			if ( this.$store.getters.isAuthenticated ) {
				this.$store.dispatch(USER_REQUEST);
				this.fetchMenu();
			}
            // Push.initializeFirebase();

			// if( this.$route.meta.authRequired && !this.$store.getters.isAuthenticated ) {
            //     router.push({name: 'Login'});
            // }
		},

		mounted() {

			window.addEventListener('online', this.updateOnlineStatus);
			window.addEventListener('offline', this.updateOnlineStatus);
			if ( 'onto1uchstart' in window && window.navigator.userAgent.toLowerCase().includes("mobi") ) {
                console.log(this.$el);
				this.$el.style.height = window.screen.availHeight + 'px';
			}
			else {
				this.$el.style.height = window.innerHeight + 'px';
			}

		},
		beforeDestroy() {
			window.removeEventListener('online', this.updateOnlineStatus);
			window.removeEventListener('offline', this.updateOnlineStatus);
		}
	};
</script>

<style>
    /*@import './assets/fonts/icons/css/fontello.css';*/
    @import './assets/css/main.css';


    /*body {*/
    /*  max-width: 480px;*/
    /*  max-height: 640px !important;*/
    /*}*/

    #login.none-leave-active .login_form .login-button {
        position: fixed;
        top: 50%;
        left: 50%;
        margin-left: -42.5px;
        margin-top: -42.5px;
    }

    .app-offline {
        position: absolute;
        top: 15px;
        color: #E4B022;
        /*background-color: red;*/
        left: 50%;
        width: 60px;
        margin-left: -30px;
        z-index: 100;
        text-align: center;
        padding: 15px;
    }

</style>



// WEBPACK FOOTER //
// src/App.vue